import PageApp from 'pageApp';
import Util from './Util';

export default {
  isTrue(property) {
    const value = false;
    if (PageApp.getMeta) {
      const properties = PageApp.getMeta('properties');
      return Boolean(properties && properties[property]);
    }

    return value;
  },
  isProsZonesExpansionEnabled() {
    if (Util.isMobile()) {
      return this.isTrue('canvasDrivenProsZonesMobileEnabled');
    }
    return this.isTrue('canvasDrivenProsZonesEnabled');
  },
};

